module.exports = __webpack_public_path__ + "img/sixpackcarrier32.b98ee469.jpg";